import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Layout from '../Layout';

class Row1 extends Component{
  render(){
    return(
      <Layout {...this.props} type="Row"></Layout>
    )
  }
}

Row1.propTypes = {
  childOf:PropTypes.string,
  values:PropTypes.object,
  cell: PropTypes.array,
  layout:PropTypes.func
};

export default Row1;



// WEBPACK FOOTER //
// ./src/contents/editorPreview/layout/components/Row/Row1.js